@if(source) {
@if(source.type === 'becomePro') {
<become-pro-banner2 class="block"
                    [mode]="source.isTradeCustomer ? 'rrp' : 'offer'"
                    [product]="product"></become-pro-banner2>

} @else {
<div class="bg-col-2 b-radius-4 center p-t-2 p-b-2 p-l-1 p-r-1 s2"
     [style.backgroundColor]="source.color || ''">
    @switch(source.type) {
    @case('wasPrice') {
    <span class="col-w">
        {{ 'WAS' | translate }}
        <price [value]="source.wasPrice"></price>
    </span>
    <span class="col-6">
        {{ 'SAVE' | translate }}
        <price [value]="source.discount"></price>
        @if(!client.isL ) {
        &nbsp;({{ source.percent }}%)
        }
    </span>
    }
    @case('bulkPrice') {
    <span class="col-6">{{ 'BULK SAVING' | translate }}</span>
    <span class="col-w">&nbsp;-&nbsp;
        <button (click)="openTierPriceModal()"
                [status]="bulkStatus"
                [inlineButton]="true">{{ 'VIEW OFFER' | translate }}</button>
    </span>
    }
    @case('label') {
    <span class="col-w"
          [innerHTML]="source.label"></span>
    }
    }
</div>
}
}